<template>
  <div class="g-hd">
    <div class="m-header f-clearfix t-header">
      <div
        class="nav-logo"
        :style="
          pathName == '/childIndex' || pathName == '/ruralIndex'
            ? 'max-width:450px'
            : 'max-width:300px'
        "
      >
        <a href="/index" :title="maessage.title">
          <img :src="imgUrl + maessage.logo" :alt="maessage.title" />
          <div
            class="nav-logo-span"
            v-if="
              pathKey &&
              (pathName == '/childIndex' ||
                pathName == '/ruralPromote' ||
                pathName == '/ruralIndex')
            "
          >
            <div class="nav-logo-span2"></div>
            <div>
              <!-- {{ pathKey == 2 ? "高等本科" : (pathKey == 3 ? "职业教育" :( pathKey == 6 ? "乡村振兴":"")) }} -->
              {{
                [
                  '主站',
                  '高等本科',
                  '职业教育',
                  '研究生教育',
                  '继续教育',
                  '乡村振兴',
                ][pathKey - 1]
              }}
            </div>
          </div>
        </a>
      </div>

      <el-menu
        :default-active="menuIndex"
        mode="horizontal"
        @select="handleSelect"
        class="nav-menu"
        v-if="
          pathFlag != 1 &&
          pathFlag != 2 &&
          pathFlag != 3 &&
          pathFlag != 4 &&
          pathFlag != 5 &&
          pathFlag != 6
        "
      >
        <!-- <el-submenu index>
            <el-menu-item index></el-menu-item>
        </el-submenu>-->
        <el-menu-item index="/index">首页</el-menu-item>
        <el-menu-item index="/course">课程</el-menu-item>
        <el-menu-item index="/school">院校</el-menu-item>
        <el-menu-item index="/teacher">教师</el-menu-item>
        <el-menu-item index="/active">活动</el-menu-item>
        <el-menu-item index="/news">资讯</el-menu-item>
      </el-menu>
      <div v-else style="flex: 1"></div>
      <div class="nav-right">
        <div class="nav-search">
          <el-input
            placeholder="输入课程关键字搜索"
            size="medium"
            v-model.trim="courseKey"
            @keyup.native.enter="
              getCourse(
                `/course?pathFalg=new&categoryId=&tagCourseId=&collegeId=&tagProjectId=&status=&key=${
                  courseKey || ''
                }`
              )
            "
          >
            <i
              slot="suffix"
              class="el-icon-search"
              @click="
                getCourse(
                  `/course?pathFalg=new&categoryId=&tagCourseId=&collegeId=&tagProjectId=&status=&key=${
                    courseKey || ''
                  }`
                )
              "
            ></i>
          </el-input>
        </div>
        <div
          class="nav-right-user"
          v-if="userMsg != '' && userMsg != undefined"
        >
          <el-dropdown :hide-timeout="200">
            <a href="javascript:;" class="m-menu-box el-dropdown-link">
              <img
                :src="
                  userMsg.avatar
                    ? imgUrl + userMsg.avatar
                    : '/images/avatar_normal_200.jpg'
                "
                alt
                class="m-user-head"
              />
              <span class="m-menu-btn m-header-btn">
                {{ userMsg ? userMsg.realName || userMsg.userName : '' }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
            </a>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                ><a href="/myIndex">个人中心</a>
              </el-dropdown-item>
              <!-- <el-dropdown-item @click.native="delMsg()"
                >解除绑定</el-dropdown-item
              > -->
              <el-dropdown-item @click.native="loginOut()"
                >退出</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
<!--        <div class="m-header-btn" v-else>-->
<!--          <el-button-->
<!--            type="primary"-->
<!--            round-->
<!--            plain-->
<!--            class="new-nav-a"-->
<!--            @click="loginIn(1)"-->
<!--            size="small"-->
<!--            >登录</el-button-->
<!--          >-->
<!--          &lt;!&ndash; :href="`${this.$setting.baseURL + '/api/web/casLogin'}`" &ndash;&gt;-->
<!--          &lt;!&ndash; <span>|</span>&ndash;&gt;-->
<!--          <el-button-->
<!--            type="primary"-->
<!--            round-->
<!--            class="new-nav-a"-->
<!--            @click="loginIn(2)"-->
<!--            size="small"-->
<!--            >注册</el-button-->
<!--          >-->
<!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcode";
export default {
  name: "Header",
  // props: {
  //   status: {
  //     default() {
  //       return "logined";
  //     }
  //   }
  // },
  computed: {
    isLoginPage () {
      return this.$route.meta.loginPage;
    },
  },
  watch: {
    $route (to, form) {
      this.courseKey = to.query.key || "";
      this.pathFlag = to.query.siteId;
      this.pathKey = this.$route.query.siteId;
      if (this.pathKey) {
        document.title = [
          "主站",
          "高等本科",
          "职业教育",
          "研究生教育",
          "继续教育",
          "乡村振兴",
        ][this.pathKey - 1];
      }
    },
  },
  data () {
    return {
      courseKey: "",
      menuIndex: "/index",
      userMsg: {},
      imgUrl: this.$setting.fdsDomain,
      maessage: {},
      pathFlag: this.$utils.getUrlParamter("siteId"),
      pathKey: localStorage.getItem("pathKey")
        ? localStorage.getItem("pathKey")
        : "",
      pathName: "",
    };
  },

  mounted () {
    this.userMsg = this.vx_userInfo;
    this.getMessage();
    this.getLinks();
    let url = window.location.pathname;
    this.menuIndex = url;
    this.getCurrentUser();
    this.pathName = window.location.pathname;
    console.log(this.pathKey)
    console.log(this.pathName)
  },
  methods: {
    handleSelect (index, key, keyPath) {
      console.log(index, key, keyPath);

      if (index == "/course") {
        location.href =
          "/course?pathFalg=new&categoryId=&tagCourseId=&collegeId=&tagProjectId=&status=&key=";
      } else {
        location.href = index;
      }
    },
    // 个人中心
    userIndo () {
      this.$router.push({ path: "/myIndex" });
      // return window.open(`http://www.icourse163.org/home.htm`);
    },
    // 解除绑定操作
    delMsg () {
      this.$confirm("是否进行账号解除绑定操作?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http
          .post("/api/web/user/unbindMooc")
          .then((res) => {
            this.$confirm("账号解绑成功，请重新登录?", "提示", {
              confirmButtonText: "确定",
              type: "success",
              showCancelButton: false,
            }).then(() => {
              this.loginOut();
            });
          })
          .catch((msg) => {
            console.log(msg);
          });
      });
    },
    getCurrentUser () {
      this.$http
        .post("/api/web/user/getUserInfo")
        .then((data) => {
          let { msg, code } = data;
          this.$store.dispatch("updateUserInfo", data.data);
        })
        .catch(({ code, msg }) => { });
    },
    getCourse (url) {
      location.href = url;
    },
    loginIn (val) {
      // let cacheId =
      //   ("000000" + Math.floor(Math.random() * 999999)).slice(-6) +
      //   new Date().getTime();
      if (val == 1) {
        window.location.href = "/login";
      } else {
        window.location.href = `/login?pathFlag=${false}`;
      }
      // this.$setting.baseURL + "/api/web/casLogin?cacheId=" + cacheId;
    },
    // 退出登录
    loginOut () {
      this.$message.success("正在退出...");
      this.$store.dispatch("logout");
      // this.$router.push("/login");
    },
    // 获取配置信息并缓存
    getMessage () {
      let protalMsg = localStorage.getItem("maessage")
        ? JSON.parse(localStorage.getItem("maessage"))
        : [];
      if (
        protalMsg.length < 1 ||
        !protalMsg.time ||
        protalMsg.time < new Date().getTime()
      ) {
        this.$http
          .post("/api/web/config/getConfig")
          .then((res) => {
            this.maessage = res.data;
            localStorage.setItem(
              "maessage",
              JSON.stringify({
                time: new Date().getTime() + 1000 * 60 * 2,
                content: res.data,
              })
            );
            //通过缓存获取网站基本配置信息
            let protalContent = JSON.parse(localStorage.getItem("maessage"));
            if (protalContent != null) {
              this.$setting.title_suffix = protalContent.content.title;
            }
          })
          .catch((msg) => {
            console.log(msg);
          });
      } else {
        this.maessage = protalMsg.content;
        //通过缓存获取网站基本配置信息
        let protalContent = JSON.parse(localStorage.getItem("maessage"));
        console.log(protalContent);
        if (protalContent != null) {
          this.$setting.title_suffix = protalContent.content.title;
        }
      }
    },
    // 获取友情链接并缓存
    getLinks () {
      let protalMsg = localStorage.getItem("msgLinks")
        ? JSON.parse(localStorage.getItem("msgLinks"))
        : [];
      if (
        protalMsg.length < 1 ||
        !protalMsg.time ||
        protalMsg.time < new Date().getTime()
      ) {
        this.$http
          .post("/api/web/config/getLinks")
          .then((res) => {
            this.links = res.data;
            localStorage.setItem(
              "msgLinks",
              JSON.stringify({
                time: new Date().getTime() + 1000 * 60 * 2,
                links: res.data,
              })
            );
          })
          .catch((msg) => {
            console.log(msg);
          });
      }
    },
  },
};
</script>

<style lang="scss">
.t-header {
  height: 70px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .nav-logo {
    display: flex;
  }
  .nav-menu {
    flex: 1;
  }
  .nav-right {
    max-width: 440px;
  }
}
.nav-logo {
  display: inline-block;
  max-width: 300px;
  height: 30px;
  line-height: 30px;
  margin-right: 30px;
  vertical-align: middle;
  overflow: hidden;
  a {
    display: flex;
    img {
      width: 100%;
    }
    .nav-logo-span {
      color: #2f3440;
      margin-left: 5px;
      display: flex;
      align-items: center;
      min-width: 120px;
      .nav-logo-span2 {
        width: 2px;
        height: 2px;
        background: #2f3440;
        border-radius: 50%;
        margin: 0 10px 0 5px;
      }
    }
  }
}
.m-header .nav-menu {
  display: inline-block;
  vertical-align: middle;
  .el-menu-item {
  }
}
.nav-right {
  display: flex;
  div {
    display: inline-block;
    // line-height: 70px;

    a {
      margin-left: 20px;
      cursor: pointer;
    }
  }
  .nav-search {
    //margin-right: 30px;
    width: 260px;
    .el-input__suffix {
      right: 0;
    }
    .el-icon-search {
      cursor: pointer;
      font-size: 18px;
      padding: 9px;
      vertical-align: middle;
    }
  }
  .nav-right-user {
    line-height: 36px;
    img {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      vertical-align: middle;
      margin-right: 10px;
    }
    .m-header-btn {
      display: inline-block;
    }
  }
  .m-header-btn {
    display: flex;
    span {
      display: inline;
      margin: 0 10px;
    }
    a {
      margin: 0;
    }
  }
}
</style>
<style lang="scss" >
// 全国哀悼日置灰代码
// html {
//   filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
//   -webkit-filter: grayscale(100%);
// }
</style>
